<template>
    <div class="outer-box">
        <div class="m-portlet  m-portlet--head-sm left  m-b-0">
            <div class="m-portlet__head">
                <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                        <h3 class="m-portlet__head-text">
                            筛选条件
                        </h3>
                    </div>
                </div>
            </div>
            <div class="m-portlet__body m-portlet__body--small-padding ">
                <el-form label-position="top">
                    <el-form-item label="筛选产生批次">
                        <el-date-picker
                                v-model="form.activeBatch"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd"
                                style="width: 350px"
                                :clearable="true"
                                @change="handleInvoiceRefund(date)">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="筛选发送批次">
                        <el-date-picker
                                v-model="form.sendingBatch"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd"
                                style="width: 350px"
                                :clearable="true"
                                @change="handleInvoiceRefund(date)">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="筛选确认批次">
                        <el-date-picker
                                v-model="form.finishedBatch"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd"
                                style="width: 350px"
                                :clearable="true"
                                @change="handleInvoiceRefund(date)">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="筛选状态">
                        <el-select v-model="form.status" clearable placeholder="请选择状态" filterable remote
                                   @change="handleInvoiceRefund()">
                            <el-option
                                    v-for="item in status"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="类型">
                        <el-select v-model="form.type" clearable placeholder="请选择类型" filterable remote
                                   @change="handleInvoiceRefund()">
                            <el-option
                                    v-for="item in types"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div class="card">
                    <div class="card-body">
                        <div class="m-b-10">
                            <div>总金额：{{sum_price}}</div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="m-portlet right m-b-0">
            <div class="m-portlet__body" :style="{'height':clientHeight-96-61.59+'px'}" v-loading="loading">
                <el-table v-if="!loading"
                          :data="orderInvoiceRefunds"
                          style="width: 100%"
                          :height="clientHeight-96-61.59-2.2-2-13-10"
                          size="middle"
                >
                    <el-table-column prop="name" label="退款编号"></el-table-column>
                    <el-table-column prop="student_name" label="学生"></el-table-column>
                    <el-table-column prop="grade_name" label="年级"></el-table-column>
                    <el-table-column prop="balance" label="金额"></el-table-column>
                    <el-table-column prop="active_date" label="生成批次"></el-table-column>
                    <el-table-column prop="sending_date" label="发送批次"></el-table-column>
                    <el-table-column prop="finished_date" label="完成批次"></el-table-column>
                    <el-table-column label="票据">
                        <template slot-scope="scope">
                            <div v-if="scope.row.invoice_photo">
                                <el-popover
                                        placement="right"
                                        trigger="click">
                                    <img :src="scope.row.invoice_photo.photo_url" style="width: 500px;height: 500px">
                                    <div slot="reference" @click="" style="width: 50px;height: 50px">
                                        <img :src="scope.row.invoice_photo.photo_url" alt=""
                                             style="width: 50px;height: 50px">
                                    </div>
                                </el-popover>
                            </div>
                            <div v-else>
                                无
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            <div v-if="scope.row.status==='active' || scope.row.status==='sending'">
                                退款中
                            </div>
                            <div v-else>
                                已完成
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <div>
                                <el-button type="primary" @click="handleChangeRefund(scope.row.id,'finished')"
                                           :disabled="scope.row.status==='finished' || scope.row.status==='active'"
                                           :loading="button_loading">确认完成
                                </el-button>
                            </div>
                            <div>
                                <el-button type="primary" @click="handleChangeRefund(scope.row.id,'sending')"
                                           :disabled="scope.row.status==='sending' || scope.row.status==='finished'"
                                           :loading="button_loading">确认发送
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="m-portlet__foot">
                <!--分页-->
                <div class="text-center">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="10"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "BalanceDetailModal",
        data() {
            return {
                path: "/refund/list",
                invoiceRefunds: [],
                sum_price: 0,
                form: {
                    activeBatch: '',
                    sendingBatch: '',
                    finishedBatch: '',
                    active_startDate_batch: '',
                    active_endDate_batch: '',
                    sending_startDate_batch: '',
                    sending_endDate_batch: '',
                    finished_startDate_batch: '',
                    finished_endDate_batch: '',
                    status: '',
                    type:''
                },
                status: [
                    {
                        id: 'active',
                        name: '退款中'
                    },
                    {
                        id: 'sending',
                        name: '已发送'
                    },
                    {
                        id: 'finished',
                        name: '已完成'
                    }
                ],
                types:[
                    {
                        id:'normal',
                        name:'正常'
                    },
                    {
                        id:'rent',
                        name:'租金'
                    }
                ],
                loading: false,
                button_loading: false,
                total: 0,
                currentPage: 1,
                currentPageSize: 10,
            }
        },
        created() {
            this.handleCreate();
            this.handleInvoiceRefund();
        },
        computed: {
            orderInvoiceRefunds: function () {
                return this._.orderBy(this.invoiceRefunds, 'id', 'desc');
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        methods: {
            handleCreate() {
                this.$wApi.addListen(this.path, this.handleData);
            },
            handleInvoiceRefund(currentPage = 1) {
                if (currentPage === 1) {
                    this.currentPage = 1
                }
                if (this.form.activeBatch == null || !this.form.activeBatch) {
                    this.form.active_startDate_batch = '';
                    this.form.active_endDate_batch = '';
                } else {
                    this.form.active_startDate_batch = this.form.activeBatch[0];
                    this.form.active_endDate_batch = this.form.activeBatch[1];
                }

                if (this.form.sendingBatch == null || !this.form.sendingBatch) {
                    this.form.sending_startDate_batch = '';
                    this.form.sending_endDate_batch = '';
                } else {
                    this.form.sending_startDate_batch = this.form.sendingBatch[0];
                    this.form.sending_endDate_batch = this.form.sendingBatch[1];
                }

                if (this.form.finishedBatch == null || !this.form.finishedBatch) {
                    this.form.finished_startDate_batch = '';
                    this.form.finished_endDate_batch = '';
                } else {
                    this.form.finished_startDate_batch = this.form.finishedBatch[0];
                    this.form.finished_endDate_batch = this.form.finishedBatch[1];
                }
                this.$wApi.send(this.path, 'list', {
                    'currentPage': currentPage,
                    'currentPageSize': this.currentPageSize,
                    'form': this.form,
                });
            },
            handleData(event, data) {
                switch (event) {
                    case 'subscribe':
                        break;
                    case 'list':
                        this.invoiceRefunds = data.invoiceRefunds;
                        this.sum_price = data.sum_price;
                        this.total = data.total;
                        this.loading = false;
                        break;
                    case 'change_refund':
                        this.$message({
                            message: '确认成功',
                            type: 'success'
                        });
                        this.button_loading = false;
                        this.$set(this.invoiceRefunds,data.invoiceRefund.id,data.invoiceRefund);
                        break;
                    case 'change_refund_error':
                        this.button_loading = false;
                        break;


                }
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.loading = true;
                this.handleInvoiceRefund(this.currentPage)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loading = true;
                this.handleInvoiceRefund(this.currentPage)
            },
            handleChangeRefund(id, status) {
                this.button_loading = true;
                this.$confirm('确认发送?', '提示', {
                    StartReturn: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$wApi.send(this.path, 'change_refund', {'id': id, 'status': status});
                }).catch(() => {
                    this.button_loading = false;
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
        }
    }
</script>

<style scoped>
    .left {
        float: left;
        width: 400px;
    }

    .outer-box {
        height: 100%;
    }

    .right {
        margin-left: 405px;
    }
</style>